export const AUTH_STATE_ENUM = {
  NON_LOGIN: "NON_LOGIN",
  LOGIN: "LOGIN",
  PUBLIC: "PUBLIC",
};
